import React from 'react';
import { PiggyBank, Calendar } from 'lucide-react';

const ContributionsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  contributionFrequencies 
}) => {
  if (!formData.includeAdditionalContributions) return null;

  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PiggyBank className="w-5 h-5 mr-2 text-green-500" />
        Регулярные взносы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сумма регулярного взноса */}
        <div>
          <label htmlFor="additionalContribution" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Сумма регулярного взноса
          </label>
          <input
            type="text"
            id="additionalContribution"
            name="additionalContribution"
            value={formData.additionalContribution}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.additionalContribution ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.additionalContribution && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.additionalContribution}
            </p>
          )}
        </div>

        {/* Периодичность взносов */}
        <div>
          <label htmlFor="contributionFrequency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-green-500" />
            Периодичность взносов
          </label>
          <select
            id="contributionFrequency"
            name="contributionFrequency"
            value={formData.contributionFrequency}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.contributionFrequency ? 'input-error' : ''}`}
          >
            {contributionFrequencies.filter(f => f.id !== 'none').map((frequency) => (
              <option key={frequency.id} value={frequency.id}>
                {frequency.name}
              </option>
            ))}
          </select>
          {errors.contributionFrequency && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.contributionFrequency}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <PiggyBank className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              О регулярных взносах
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Регулярные взносы значительно увеличивают итоговую сумму за счет эффекта 
              сложных процентов. Рекомендуется добавлять их автоматически (например, 
              настроив регулярный перевод в банке сразу после получения зарплаты).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContributionsSection;